import React, { useEffect, useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../api/api";
import parse from "html-react-parser";
import { useProfileStore } from "../../store/useUserStore";
import { FiUserPlus } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { formatDate, isImageFile, isPDFFile } from "../../helpers/helper";

type Props = {};

const InboxView = (props: Props) => {
  const navigate = useNavigate();
  const [notification, setNotification] = useState<any>({});
  let { id } = useParams();
  const { profile, setLoading } = useProfileStore((state) => state);
  const { t } = useTranslation();

  useEffect(() => {
    if (id !== "0") {
      setLoading(true);
      api
        .get(`${process.env.REACT_APP_API_BASE_URL}/notification/${id}`)
        .then((res) => {
          setLoading(false);
          console.log("notification", res.data.data);
          setNotification(res.data.data);
        })
        .catch((err) => {
          setLoading(false);
          console.log("err cart", err);
        });
    }
  }, []);

  if (id === "0") {
    if (!profile) return null;

    return (
      <div className="pb-28 text-base">
        <div className="mb-2 grid grid-cols-4 px-2">
          <div>
            <IoIosArrowBack
              size={28}
              color="#000"
              onClick={() => navigate("/inbox")}
            />
          </div>
          <div className="text-center col-span-2 text-lg font-medium"></div>
          <div></div>
        </div>

        <div className="pb-2 py-2 mx-2">
          <div className="grid grid-cols-12 gap-2 p-2.5 items-center ">
            <div className="col-span-2 md:col-span-1">
              <img
                src={"/assets/img/koku-logo.png"}
                alt=""
                className="w-10 h-10 rounded-3xl"
              />
            </div>
            <div className="col-span-10 md:col-span-11">
              <div className="text-lg font-semibold">MYKOKU</div>
            </div>
          </div>

          <div className="px-3 mt-6 text-base">
            <div className="font-bold">
              {`${t("notification_registration.greeting")} ${profile.name},`}
              {t("notification_registration.welcome")}
            </div>
            <div className="mt-3">{t("notification_registration.intro")}</div>
            <div className="mt-4 text-center font-semibold underline italic">
              {t("notification_registration.complete_profile")}
            </div>
            <div className="mt-3">
              <img src={"/assets/img/welcome-notification-steps.png"} alt="" />
            </div>
            <button
              onClick={() => navigate("/profile")}
              className="mt-3 gap-3 text-white text-[16px] leading-none w-full py-[13px] bg-theme border-none rounded-3xl flex items-center justify-center"
            >
              <FiUserPlus /> {t("home.go_to_profile")}
            </button>
            <hr />
            <div className="font-semibold underline italic">
              {t("notification_registration.more_features_title")}
            </div>
            <div className="italic">
              {t("notification_registration.feature_attendance")}
            </div>
            <div className="italic">
              {t("notification_registration.feature_payment")}
            </div>
            <div className="italic">
              {t("notification_registration.feature_schedule")}
            </div>
            <div className="mt-3">
              {t("notification_registration.support_message")}
            </div>
            <div className="mt-3">{t("notification_registration.closing")}</div>
            <div
              className="mt-3"
              dangerouslySetInnerHTML={{
                __html: t("notification_registration.regards").replace(
                  /\n/g,
                  "<br/>",
                ),
              }}
            ></div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="pb-28">
        <div className="mb-2 grid grid-cols-4 px-2">
          <div>
            <IoIosArrowBack
              size={28}
              color="#000"
              onClick={() => navigate("/inbox")}
            />
          </div>
          <div className="text-center col-span-2 text-lg font-medium"></div>
          <div></div>
        </div>

        <div className="pb-2 py-2 mx-2">
          <div className="grid grid-cols-12 gap-2 p-2.5 items-center ">
            <div className="col-span-3">
              <img
                src={notification.sender_pic || "/assets/img/koku-logo.png"}
                alt=""
                className="w-10 h-10 rounded-3xl"
              />
            </div>
            <div className=" col-span-9">
              <div className="text-lg font-semibold">
                {notification.sender_name || "-"}
              </div>
              <div className="text-md font-light">
                {notification.sent_at ? formatDate(notification.sent_at) : "-"}
              </div>
            </div>
          </div>

          <div className="px-3 mt-6 text-xl font-semibold">
            {notification.title}
          </div>

          <div className="px-3 mt-3 text-lg">
            {notification.descriptions &&
              parse(notification.descriptions?.replace(/\n/g, "<br />") || "")}
          </div>

          <div className="px-3 mt-3 text-lg">
            {(notification.attachements && notification.attachements.length) >
              0 && (
                <div className="space-y-3">
                  {notification.attachements.map(
                    (attachment: any, index: number) => {
                      if (isImageFile(attachment)) {
                        return (
                          <img
                            key={index}
                            src={attachment}
                            alt={`Attachment ${index}`}
                            className="image-class"
                          />
                        );
                      } else if (isPDFFile(attachment)) {
                        return (
                          <a
                            key={index}
                            href={attachment}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-2 p-3 bg-gray-100 rounded-lg hover:bg-gray-200"
                          >
                            <svg
                              className="w-6 h-6 text-red-600"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M4 18h12V6h-4V2H4v16zm8-14v4h4l-4-4z" />
                            </svg>
                            <span className="text-base">
                              PDF Document {index + 1}
                            </span>
                          </a>
                        );
                      }
                      return null;
                    },
                  )}
                </div>
              )}
          </div>
        </div>
      </div>
    );
  }
};

export default InboxView;
